<template lang="html">
  <div class="wcc buttons margin">
    <button class="button" v-hammer:tap="toFlat">Flat</button>
    <button class="button" v-hammer:tap="toSplit">Split</button>
  </div>
</template>
<script>
  import { flatRateListing, flatRateBuying, splitRateBuying, splitRateListing } from '@/models.js'
  export default {
    props: ['commissionData', 'agent', 'updateDefaults'],
    methods: {
      toSplit() {
        if (this.agent == 'buying') {
          this.commissionData.value = new splitRateBuying(this.calculatorDataDefaults, this.updateDefaults)
        } else {
          this.commissionData.value = new splitRateListing(this.calculatorDataDefaults, this.updateDefaults)
        }
        this.$store.dispatch('appInput/commitInput')
      },
      toFlat() {
        if (this.agent == 'buying') {
          this.commissionData.value = new flatRateBuying(this.calculatorDataDefaults, this.updateDefaults)
        } else {
          this.commissionData.value = new flatRateListing(this.calculatorDataDefaults, this.updateDefaults)
        }
        this.$store.dispatch('appInput/commitInput')
      }
    },
    computed: {
      calculatorDataDefaults() {
        return this.$store.state.calculatorDataDefaults
      }
    }
  }
</script>
<style lang="scss">
</style>